import { BookOpen, LucideIcon } from "lucide-react";
import * as LucideIcons from "lucide-react";

// This utility file helps map string icon names from the database to Lucide icon components

export type IconName = string;

/**
 * Maps a string icon name to a Lucide icon component
 * @param iconName The string name of the icon
 * @returns The corresponding Lucide icon component or BookOpen as default
 */
export function getIconFromString(iconName?: IconName): LucideIcon {
  if (!iconName) return BookOpen;

  // Convert kebab-case to PascalCase (e.g., "building-2" -> "Building2")
  const pascalCaseName = iconName
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join("");

  // Handle special cases for icons that don't follow the pattern
  const specialCaseMappings: Record<string, string> = {
    tool: "Wrench", // Map "tool" to "Wrench" since "Tool" doesn't exist
  };

  // Check if we have a special mapping for this icon name
  const iconComponentName = specialCaseMappings[iconName] || pascalCaseName;

  // Try to get the icon from the Lucide icons object (dynamic string access
  // isn't a type error under this project's non-strict tsconfig, unlike the
  // sols-energy original this was ported from).
  const IconComponent = (LucideIcons as unknown as Record<string, LucideIcon>)[
    iconComponentName
  ];

  // Return the icon if found, or BookOpen as a fallback
  return IconComponent || BookOpen;
}
